export const environment = {
  production: false,
  base_url: 'https://dev.api.framework.holadoc.com',
  assets_url: 'https://sinapsis-dev.s3.amazonaws.com',
  socketUrl: 'https://dev.api.framework.holadoc.com',
  clevertapId: '4WK-66R-5Z7Z',
  clevertapActive: true,
};
